<template>
	<ui-card
		icon="fal fa-cogs"
		title="Novos Cadastros"
		text="Essas são configurações referentes aos novos cadastros."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-util-box-text-slot title="Aprovar novos cadastros." design="mb">
					<ui-switch
						v-model="form.brokerApprove"
						:checked="form.brokerApprove"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<div class="internal-header line-t">
					<h2 class="title">Campo Identificador</h2>
					<span class="desc"
						>Utilize esse campo caso os seus usuários tenham algum número de
						identificação. <br />
						Exemplo: Creci, Matrícula, CRP, CRM</span
					>
				</div>

				<ui-util-box-text-slot title="Habilitar campo Identificador." design="mb">
					<ui-switch
						v-model="disabled.fieldIdentifier"
						:checked="disabled.fieldIdentifier"
						@click="cleanFieldIdentifier"
						design="xs"
					/>
				</ui-util-box-text-slot>

				<ui-input
					v-model="form.fieldIdentifier"
					v-show="disabled.fieldIdentifier"
					:disabled="!disabled.fieldIdentifier"
					placeholder="Digite o nome do campo."
					label="Nome do campo identificador:"
					type="text"
				/>

				<div class="internal-header line-t">
					<h2 class="title">Campo CPF</h2>
					<span class="desc"
						>Habilite o campo cpf para utilizá-lo no cadastro de corretores.</span
					>
				</div>

				<ui-util-box-text-slot title="Habilitar campo CPF.">
					<ui-switch v-model="form.fieldCpf" :checked="form.fieldCpf" design="xs" />
				</ui-util-box-text-slot>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch, uiInput } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	const defaultForm = () => ({
		brokerApprove: false,
		fieldIdentifier: '',
		fieldCpf: false,
	})

	const defaultDisabled = () => ({
		brokerApprove: false,
		fieldIdentifier: true,
		fieldCpf: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-users-general',

		components: {
			uiCard,
			uiButton,
			uiSwitch,
			uiInput,
			uiLoadSuccess,
			uiLoadIndicator,
			uiUtilBoxTextSlot,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		async created() {
			this.loader.body = true

			const [brokerApprove, fieldIdentifier, fieldCpf] = await Promise.all([
				this.getConfig('brokerApprove'),
				this.getConfig('fieldIdentifier'),
				this.getConfig('fieldCpf'),
			])

			this.form.brokerApprove = this.$mx_checkIsActive(brokerApprove)
			this.form.fieldIdentifier = fieldIdentifier
			this.form.fieldCpf = this.stringToBoolean(fieldCpf)

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		computed: {
			canSubmit() {
				return (
					this.$mx_isFormChanged &&
					((!this.disabled.fieldIdentifier && !this.form.fieldIdentifier) ||
						(this.disabled.fieldIdentifier && this.form.fieldIdentifier)) &&
					!this.loader.body
				)
			},

			brokerApproveValue() {
				return this.form.brokerApprove ? 'active' : 'inactive'
			},
		},

		methods: {
			getConfig,
			saveConfig,

			cleanFieldIdentifier() {
				if (this.disabled.fieldIdentifier) this.form.fieldIdentifier = ''
			},

			stringToBoolean(string) {
				return string == 'true'
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await Promise.all([
						this.saveConfig('brokerApprove', this.brokerApproveValue),
						this.saveConfig('fieldIdentifier', this.form.fieldIdentifier),
						this.saveConfig('fieldCpf', this.form.fieldCpf.toString()),
					])

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
